var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_352_16072",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0.5,
    width: 22,
    height: 29,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4,
    y: 0.5,
    width: 22,
    height: 29
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.667 23.5568C20.3721 19.0829 23.1333 15.7487 23.1333 11.75C23.1333 7.19365 19.5218 3.5 15.0667 3.5C10.6116 3.5 7 7.19365 7 11.75C7 15.7487 9.76127 19.0829 13.4663 23.5568C13.9831 24.1807 14.5182 24.8268 15.0667 25.5C15.6152 24.8268 16.1503 24.1807 16.667 23.5568ZM15.0653 16.3292C17.5403 16.3292 19.5468 14.2772 19.5468 11.7459C19.5468 9.2146 17.5403 7.16257 15.0653 7.16257C12.5902 7.16257 10.5838 9.2146 10.5838 11.7459C10.5838 14.2772 12.5902 16.3292 15.0653 16.3292Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 23.5568L18.5924 25.1513H18.5924L16.667 23.5568ZM13.4663 23.5568L11.5409 25.1513L13.4663 23.5568ZM15.0667 25.5L13.1286 27.0792L15.0667 29.4577L17.0048 27.0792L15.0667 25.5ZM20.6333 11.75C20.6333 13.1332 20.1671 14.5132 19.1548 16.1742C18.1149 17.8804 16.6289 19.6832 14.7415 21.9622L18.5924 25.1513C20.4102 22.9564 22.1573 20.8552 23.4243 18.7762C24.719 16.652 25.6333 14.3654 25.6333 11.75H20.6333ZM15.0667 6C18.0884 6 20.6333 8.5211 20.6333 11.75H25.6333C25.6333 5.8662 20.9551 1 15.0667 1V6ZM9.5 11.75C9.5 8.5211 12.0449 6 15.0667 6V1C9.17819 1 4.5 5.8662 4.5 11.75H9.5ZM15.3918 21.9622C13.5044 19.6832 12.0184 17.8804 10.9786 16.1742C9.96627 14.5132 9.5 13.1332 9.5 11.75H4.5C4.5 14.3654 5.41437 16.652 6.70899 18.7762C7.976 20.8552 9.72317 22.9564 11.5409 25.1513L15.3918 21.9622ZM17.0048 23.9208C16.449 23.2387 15.9077 22.5851 15.3918 21.9622L11.5409 25.1513C12.0585 25.7763 12.5873 26.4149 13.1286 27.0792L17.0048 23.9208ZM14.7415 21.9622C14.2257 22.5851 13.6844 23.2387 13.1286 23.9208L17.0048 27.0792C17.546 26.4149 18.0749 25.7763 18.5924 25.1513L14.7415 21.9622ZM17.0468 11.7459C17.0468 12.9498 16.107 13.8292 15.0653 13.8292V18.8292C18.9737 18.8292 22.0468 15.6047 22.0468 11.7459H17.0468ZM15.0653 9.66257C16.107 9.66257 17.0468 10.5421 17.0468 11.7459H22.0468C22.0468 7.88715 18.9737 4.66257 15.0653 4.66257V9.66257ZM13.0838 11.7459C13.0838 10.5421 14.0236 9.66257 15.0653 9.66257V4.66257C11.1568 4.66257 8.0838 7.88715 8.0838 11.7459H13.0838ZM15.0653 13.8292C14.0236 13.8292 13.0838 12.9498 13.0838 11.7459H8.0838C8.0838 15.6047 11.1568 18.8292 15.0653 18.8292V13.8292Z",
    fill: "#2D2C3C",
    mask: "url(#path-1-outside-1_352_16072)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.1c6cecf25030f62f8fcfc25bf125f960.svg";
export { ForwardRef as ReactComponent };